import {isValidPhoneNumber, parsePhoneNumberFromString, type CountryCode} from 'libphonenumber-js/max';

const NUMBER_LIKE = /^[+\d][\d\s()-]{2,}$/;

export const looksLikeNumber = (text: string): boolean => NUMBER_LIKE.test(text.trim());

export const regionOfLine = (lineNumber: string | number | undefined): CountryCode | undefined =>
    lineNumber === undefined ? undefined : parsePhoneNumberFromString(`+${String(lineNumber).replace(/^\+/, '')}`)?.country;

export const toDialableNumber = (text: string, region: CountryCode | undefined): string | undefined => {
    const compact = text.replace(/[\s()-]/g, '').replace(/^00/, '+');
    if (!compact) {
        return undefined;
    }
    const parsed = compact.startsWith('+') ? parsePhoneNumberFromString(compact) : parsePhoneNumberFromString(compact, region);
    return parsed && isValidPhoneNumber(parsed.number) ? parsed.number : undefined;
};

export const formatDialable = (e164: string): string => parsePhoneNumberFromString(e164)?.formatInternational() ?? e164;

export const countryNameOf = (number: string | undefined, locale: string): string | undefined => {
    const country = number ? parsePhoneNumberFromString(`+${number.replace(/[^\d]/g, '')}`)?.country : undefined;
    if (!country) {
        return undefined;
    }
    try {
        return new Intl.DisplayNames([locale], {type: 'region'}).of(country) ?? undefined;
    } catch {
        return undefined;
    }
};
